import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import AsideNavbar from '../components/navbars/AsideNavbar';
import Navbars from '../components/navbars/Navbars';
import DoubtTracking from '../components/Doubts/DoubtTracking';
import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import { DOUBT_DESK_CSS } from '../components/Doubts/doubtDeskStyles';

const GET_DOUBTS = gql`
  query($mobile: String!) {
    getDoubts(mobile: $mobile) {
      id
      title
      description
      image_path
      doubt_status
      raised_time
      timestamp
    }
  }
`;

const GET_DOUBT_TRACKING = gql`
  query($doubt_id: Int!) {
    getDoubtTracking(doubt_id: $doubt_id) {
      id
      answer
      image_path
      name
      doubts_user_type
      timestamp
    }
  }
`;

const ADD_DOUBT_ANSWER = gql`
  mutation($params: DoubtTrackingInput!) {
    addDoubtAnswer(params: $params)
  }
`;

class DoubtDetails extends Component {
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");

        const doubtId = this.props.match.params.id;

        return (
            <div className={Cookies.get("toggle") || "wrapper"}>
                <style>{DOUBT_DESK_CSS}</style>
                <div className="header-area">
                    <Navbars onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">
                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper">
                        <Container fluid className="py-3">
                            {/* Back bar */}
                            <div className="d-flex align-items-center mb-3" style={{ gap: 12 }}>
                                <button
                                    type="button"
                                    onClick={() => this.props.history.goBack()}
                                    className="d-inline-flex align-items-center"
                                    style={{
                                        gap: 6, border: "1px solid #e2e8f0", background: "#fff",
                                        borderRadius: 10, padding: "7px 14px", fontSize: 13, fontWeight: 600,
                                        color: "#334155", cursor: "pointer",
                                    }}
                                >
                                    <i className="fas fa-arrow-left" style={{ fontSize: 12 }} /> Back
                                </button>
                                <div className="d-flex align-items-center" style={{ gap: 8, color: "#64748b", fontSize: 13 }}>
                                    <i className="fas fa-comments" style={{ color: "#36a1f5" }} />
                                    <span className="font-weight-bold text-dark">Doubt Discussion</span>
                                </div>
                            </div>

                            {/* Framed chat panel that fills the viewport below the header */}
                            <div className="doubt-desk" style={{ height: "calc(100vh - 168px)", minHeight: 460 }}>
                                <div className="dd-chat">
                                    {(this.props.getDoubts.loading || this.props.getDoubtTracking.loading) ? (
                                        <PreloaderTwo />
                                    ) : (
                                        <DoubtTracking
                                            doubtId={doubtId}
                                            doubt={this.props.getDoubts.getDoubts ? this.props.getDoubts.getDoubts.find(d => d.id.toString() === doubtId.toString()) : null}
                                            tracking={this.props.getDoubtTracking.getDoubtTracking || []}
                                            addDoubtAnswer={this.props.addDoubtAnswer}
                                            refetch={this.props.getDoubtTracking.refetch}
                                        />
                                    )}
                                </div>
                            </div>
                        </Container>
                    </div>
                </div>
            </div>
        )
    }
}

export default compose(
    graphql(GET_DOUBTS, {
        options: props => ({
            variables: {
                mobile: Cookies.get("mobile") || ""
            },
            fetchPolicy: "cache-first"
        }), name: "getDoubts"
    }),
    graphql(GET_DOUBT_TRACKING, {
        options: props => ({
            variables: {
                doubt_id: parseInt(props.match.params.id)
            },
            fetchPolicy: "cache-and-network"
        }), name: "getDoubtTracking"
    }),
    graphql(ADD_DOUBT_ANSWER, { name: "addDoubtAnswer" })
)(DoubtDetails);
